import { PLAN_SLUGS } from '@smarty-nx/code-utils'

import { buildProductsArray } from './buildData'
import { DATA_LAYER_EVENTS } from '../constants'

// return an event name based on plan being an upgrade or a downgrade
const returnUpgradeOrDowngrade = (planData, previousPlanData) => {
  // unlimited has no data_in_gb so check for this first
  if (planData.slug === 'unlimited') {
    return DATA_LAYER_EVENTS.CHANGE_PLAN_UPGRADE
    // if previous plan is unlimited, always a downgrade
  } else if (previousPlanData.slug === 'unlimited') {
    return DATA_LAYER_EVENTS.CHANGE_PLAN_DOWNGRADE
    // if data in gb is equal, data discount is the less valuable plan
  } else if (planData.data_in_gb === previousPlanData.data_in_gb) {
    return previousPlanData.data_discount
      ? DATA_LAYER_EVENTS.CHANGE_PLAN_UPGRADE
      : DATA_LAYER_EVENTS.CHANGE_PLAN_DOWNGRADE
  }
  return planData.data_in_gb > previousPlanData.data_in_gb
    ? DATA_LAYER_EVENTS.CHANGE_PLAN_UPGRADE
    : DATA_LAYER_EVENTS.CHANGE_PLAN_DOWNGRADE
}

// Triggers a plan upgrade or downgrade event with upcoming and previous product data
export const triggerUpOrDowngradeEvent = (planData, previousPlanData) => {
  window.smDl.events.push({
    // return an upgrade or downgrade event based on product data
    event: returnUpgradeOrDowngrade(
      planData.attributes,
      previousPlanData.attributes
    ),
    ...buildProductsArray(planData, previousPlanData),
  })
}

// return an event name based on plan being an upgrade or a downgrade
export const returnV2UpgradeOrDowngrade = (planData, previousPlanData) => {
  // unlimited has no data_in_gb so check for this first
  if (planData.slug === PLAN_SLUGS.UNLIMITED) {
    return DATA_LAYER_EVENTS.CHANGE_PLAN_UPGRADE
    // if previous plan is unlimited, always a downgrade
  } else if (previousPlanData.slug === 'unlimited') {
    return DATA_LAYER_EVENTS.CHANGE_PLAN_DOWNGRADE
    // if data in gb is equal, data discount is the less valuable plan
  } else if (planData.data === previousPlanData.dataAllowanceGB) {
    return previousPlanData.planHasDataDiscount
      ? DATA_LAYER_EVENTS.CHANGE_PLAN_UPGRADE
      : DATA_LAYER_EVENTS.CHANGE_PLAN_DOWNGRADE
  }
  return planData.dataAllowanceGB > previousPlanData.dataAllowanceGB
    ? DATA_LAYER_EVENTS.CHANGE_PLAN_UPGRADE
    : DATA_LAYER_EVENTS.CHANGE_PLAN_DOWNGRADE
}

// Triggers a plan upgrade or downgrade event with upcoming and previous product data
export const triggerV2UpOrDowngradeEvent = (planData, previousPlanData) => {
  window.smDl.events.push({
    // return an upgrade or downgrade event based on product data
    event: returnV2UpgradeOrDowngrade(planData, previousPlanData),
    ...buildProductsArray(planData, previousPlanData),
  })
}
